import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card } from 'ui';
import { useSnack, useError } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Header } from 'components';
import { initialLocale } from 'utils';
import ExperienceSegmentForm from '../../../components/Forms/ExperienceSegmentForm';
import { createSegment } from 'api/node/segments';

const CreateSegment = () => {
  const { t } = useTranslation('experienceSegment');
  const [currentLocale, setCurrentLocale] = useState(initialLocale);
  const navigate = useNavigate();
  const { notify } = useSnack();
  const { sendErrorSnack } = useError();

  const handleCreateSegment = async (values) => {
    try {
      await createSegment({ payload: values, locale: currentLocale.value });

      navigate(-1);
      notify(t('createSegmentSuccess'));
    } catch (err) {
      sendErrorSnack(err);
    }
  };

  return (
    <>
      <Header />

      <Container size="narrow">
        <Card>
          <ExperienceSegmentForm
            onSubmit={handleCreateSegment}
            queryLocale={currentLocale}
            updateQueryLocale={setCurrentLocale}
            disabledCreate={currentLocale.value !== initialLocale.value}
          />
        </Card>
      </Container>
    </>
  );
};

export default CreateSegment;
